import { productsEndpoint, accountsEndpoint } from "@/lib/config/environments"
import { generateGeoSignature } from "@/lib/geolocation/generateGeoSignature"

// export const getLocation = async () => {
//   try {
//     const response = await fetch(
//       `https://pro.ip-api.com/json/?key=${process.env.NEXT_PUBLIC_IP_API_KEY}&fields=status,currency,country,countryCode`,
//     )
//     if (response.ok) {
//       return await response.json()
//     }
//     throw new Error(response.statusText)
//   } catch (error) {
//     console.log("Error", error)
//   }
//   return null
// }

export const getLocation = async () => {
  try {
    const GEO_KEY = process.env.NEXT_PUBLIC_GEOLOCATION_KEY
    if (!GEO_KEY) {
      throw new Error("GEOLOCATION_KEY is not defined")
    }
    const { timestamp, signature } =
      await generateGeoSignature(GEO_KEY)
    const response = await fetch(
      "https://mxp-api.trimble.com/geolocation/ecom",
      {
        method: "GET",
        headers: {
          "x-geo-timestamp": timestamp,
          "x-geo-signature": signature,
        },
      },
    )
    
    if (response.ok) {
      const locationData = await response.json()      
      return locationData
    }
    throw new Error(response.statusText)
  } catch (error) {
    console.log("Error", error)
  }
  return null
}


export const getCurrency = async (ISOCode, onError = () => {}) => {
  try {
    const url = `${accountsEndpoint}/currency?country=${ISOCode}`
    const response = await fetch(url)
    if (response?.ok) {
      return await response.text()
    }
    throw new Error()
  } catch (error) {
    console.log("Error", error)
    onError()
  }
  return null
}

export const getAccounts = async (
  userKey,
  onError = () => {},
  currentAccessToken = null,
) => {
  try {
    let refreshedKey
    const token = currentAccessToken
    if (token && userKey !== token) {
      refreshedKey = token
    }
    let requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${refreshedKey ? refreshedKey : userKey}`,
        "Content-Type": "application/json",
      },
    }
    const response = await fetch(`${accountsEndpoint}/accounts`, requestOptions)
    if (response.ok) {
      const data = await response.json()
      return data
    }
    throw new Error()
  } catch (error) {
    console.log("Error", error)
    onError()
  }
  return null
}

export const getAnonymousCartData = async (cartId, onError = () => {}) => {
  try {
    const url = `${productsEndpoint}/carts/${cartId}`
    const response = await fetch(url)
    const data = await response.json()
    if (response?.ok) {
      return data
    }
    if (response?.status === 404) {
      localStorage.removeItem("cartId")
      return null
    }
    throw new Error()
  } catch (error) {
    console.log("Error", error)
    onError()
  }
  return null
}

export const getRegisteredCartData = async (
  userKey,
  accountId,
  onError = () => {},
) => {
  try {
    const url = `${productsEndpoint}/carts`
    const response = await fetch(url, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${userKey}`,
        "x-client-source": "MXP",
        "x-account-id": accountId,
      },
    })
    if (response.status === 401) {
      return null
    }
    const data = await response.json()
    if (response.ok) {
      return data
    }
    if (
      data?.errorCode === "PRODUCTS_1300" ||
      data?.errorCode === "PRODUCTS_1303"
    ) {
      return null
    }
    throw new Error()
  } catch (error) {
    console.log("Error", error)
    onError()
  }

  return null
}

export const mergeAnonymousCart = async (
  userKey,
  accountId,
  anonymousCartId,
  onSubscriptionError = () => {},
  onGeolocationError = () => {},
  onMergeError = () => {},
  onError = () => {},
) => {
  try {
    const url = `${productsEndpoint}/carts/merge`
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${userKey}`,
        "x-account-id": accountId,
      },
      body: JSON.stringify({
        anonymousCartId: anonymousCartId,
      }),
    })
    const data = await response.json()
    if (data?.errorCode === "PRODUCTS_1604") {
      onSubscriptionError(data)
      return null
    }

    if (data?.errorCode === "PRODUCTS_1507" && data?.errorData?.removedSkus) {
      onGeolocationError(data)
    }

    if (data?.mergeWarning?.length) {
      onMergeError(data)
    }

    if (response?.ok) {
      return data
    }
    // throw new Error()
  } catch (error) {
    console.error("Error", error)
    onError()
  }

  return null
}

export const createAnonynousCart = async (
  currency,
  countryCode,
  lineItems,
  onGeolocationError = () => {},
  onError = () => {},
) => {
  try {
    const response = await fetch(`${productsEndpoint}/carts/anonymous`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        currency: currency,
        country: countryCode,
        lineItems: lineItems,
      }),
    })
    if (response?.ok) {
      return await response.json()
    }

    // check for US or CA anonymous cart and then switch to country outside US/CA for projectSight. This removes anonymous cart since API will fail
    const res = await response.json()
    if (
      res?.errorCode &&
      res.errorCode === "PRODUCTS_1507" &&
      res?.errorData?.removedSkus
    ) {
      onGeolocationError()
      return
    } else {
      throw new Error()
    }
  } catch (error) {
    console.error("Error", error)
    onError()
  }
  return null
}
